var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDownSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.99997L3 4.99998V12.7568H6V4.99997ZM2.99999 2.99998L5.99999 2.99997C7.10457 2.99997 8 3.8954 8 4.99997V12.7568C8 13.8614 7.10457 14.7568 6 14.7568H3C1.89543 14.7568 1 13.8614 1 12.7568V4.99998C1 3.89542 1.89542 2.99999 2.99999 2.99998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 3.75473C6.25 3.34052 6.58579 3.00473 7 3.00473H18.081C19.2496 3.00473 20.2906 3.74328 20.6766 4.84627L22.7766 10.8463C23.4024 12.6343 22.0754 14.5047 20.181 14.5047H15.6541L15.7907 14.8121C16.757 16.9862 16.2845 19.5309 14.6021 21.2133L14.5303 21.2851C14.2374 21.578 13.7626 21.578 13.4697 21.2851L6.46967 14.2851C6.32902 14.1444 6.25 13.9536 6.25 13.7547V3.75473Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownSolidStandard);
export default __webpack_public_path__ + "static/media/thumbs-down-solid-standard.1d44aa834bdfd8cd340f18af0fae4bfa.svg";
export { ForwardRef as ReactComponent };